/** Canonical entity ID helpers ({type}:{id}). */

export function formatEntityId(type: string, id: string): string {
  return `${type}:${id}`;
}

export function parseEntityId(entityId: string): { type: string; id: string } | null {
  const colon = entityId.indexOf(':');
  if (colon <= 0) return null;
  return { type: entityId.slice(0, colon), id: entityId.slice(colon + 1) };
}

export const entityId = {
  project: (id: string) => formatEntityId('project', id),
  repository: (id: string) => formatEntityId('repository', id),
  incident: (id: string) => formatEntityId('incident', id),
  investigation: (incidentId: string) => formatEntityId('investigation', incidentId),
  changeRequest: (id: string) => formatEntityId('change_request', id),
  engineeringEpisode: (id: string) => formatEntityId('engineering_episode', id),
  service: (key: string) => formatEntityId('service', key),
  workflow: (id: string) => formatEntityId('workflow', id),
  component: (id: string) => formatEntityId('component', id),
  api: (id: string) => formatEntityId('api', id),
  sourceFile: (path: string) => formatEntityId('source_file', path),
  configFile: (path: string) => formatEntityId('config_file', path),
  document: (id: string) => formatEntityId('document', id),
  dependency: (id: string) => formatEntityId('dependency', id),
  datastore: (id: string) => formatEntityId('datastore', id),
  knowledgeNode: (graphId: string) => formatEntityId('knowledge_node', graphId),
  worker: (id: string) => formatEntityId('worker', id),
  workerInsight: (id: string) => formatEntityId('worker_insight', id),
  environment: (id: string) => formatEntityId('environment', id),
};
